// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b9e9118","396":"23c65910","453":"6bd37a93","455":"08d3f7cc"}[chunkId] + ".chunk.js";
};